export default __webpack_public_path__ + "static/media/success_video.83366d74.png";